module.exports = "/_next/static/images/5ffc65a63a8025c006994ebfec868cc9-open-graph-logo.png";